import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, BedDouble, Bath, Maximize2, Eye } from 'lucide-react';
import { formatPrice, formatArea } from '../../utils/constants';
import './PropertyCard.css';

const PropertyCard = ({ property }) => {
  const cover = property.images?.find(i => i.imageType === 'COVER') || property.images?.[0];
  // Backend returns imageUrl (camelCase); demo data used image_url — handle both
  const rawUrl = cover?.imageUrl || cover?.image_url;
  // Images stored at /uploads/... on backend port 8080
  const imgUrl = rawUrl
    ? (rawUrl.startsWith('http') ? rawUrl : `${process.env.REACT_APP_MEDIA_URL || ""}${rawUrl}`)
    : 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800&q=80';

  return (
    <Link to={`/properties/${property.slug}`} className="prop-card">
      <div className="prop-card__img">
        <img src={imgUrl} alt={property.title} loading="lazy" />
        <div className="prop-card__badges">
          <span className={`badge badge--${property.listingType?.toLowerCase().replace(/[\s_]+/g,'-')}`}>{property.listingType}</span>
          {property.featured && <span className="badge badge--featured">Featured</span>}
        </div>
        {property.status === 'READY_TO_MOVE' && <span className="prop-card__rtm">Ready to Move</span>}
      </div>
      <div className="prop-card__body">
        <p className="prop-card__city"><MapPin size={13}/> {property.locality}, {property.city}</p>
        <h3 className="prop-card__title">{property.title}</h3>
        <p className="prop-card__price">{formatPrice(property.price)}</p>
        <div className="prop-card__specs">
          {property.bedrooms > 0 && <span><BedDouble size={14}/> {property.bedrooms} BHK</span>}
          {property.bathrooms > 0 && <span><Bath size={14}/> {property.bathrooms}</span>}
          {property.area && <span><Maximize2 size={14}/> {formatArea(property.area)}</span>}
        </div>
        <div className="prop-card__footer">
          <span className="prop-card__type">{property.propertyType}</span>
          {property.viewCount > 0 && <span className="prop-card__views"><Eye size={12}/> {property.viewCount}</span>}
        </div>
      </div>
    </Link>
  );
};

export default PropertyCard;
